// extracted by mini-css-extract-plugin
export default {"accentPink":"#da06e5","bgPanel":"#1a2c38","bgBase":"#0f1923","bgDropdown":"#333c4f","textPrimary":"#fff","textSecondary":"#8698a6"};